export default __webpack_public_path__ + "static/media/003-income.56316297.png";